<h1 matDialogTitle>Edit Syspro Order Line Discount</h1>

<mat-dialog-content>
  <div>
    <!-- Line Details -->
    <div>
      <form [formGroup]="form">
        <form class="dynamic-form" [formGroup]="form" style="width: 100%">
          <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

            <mat-form-field fxFlex="30" width="100%">
              <mat-label>Line</mat-label>
              <input matInput style="text-align: right;" type="number" formControlName="lineNumber">
            </mat-form-field>

            <mat-form-field fxFlex="70" width="100%">
              <mat-label>Stock Code</mat-label>
              <input matInput type="text" formControlName="stockCode">
            </mat-form-field>

            <mat-form-field fxFlex="50" width="100%">
              <mat-label>Description</mat-label>
              <input matInput type="text" formControlName="lineDescription">
            </mat-form-field>

            <mat-form-field fxFlex="50" width="100%">
              <mat-label>Additional Info</mat-label>
              <input matInput type="text" formControlName="lineDescription2">
            </mat-form-field>

            <mat-form-field fxFlex="50" width="100%">
              <mat-label>Unit RSP Incl. VAT</mat-label>
              <input matInput type="number" formControlName="unitRspIncludingVat">
            </mat-form-field>

            <mat-form-field fxFlex="50" width="100%">
              <mat-label>SYSPRO Price Contract</mat-label>
              <input matInput type="text" formControlName="contract">
            </mat-form-field>

            <mat-form-field fxFlex="100" width="100%" *ngIf="discounts && discounts.length > 0">
              <mat-label>Discount Reason</mat-label>
              <mat-select formControlName="discountId" (selectionChange)="discountChanged($event.value)">
                <mat-option *ngFor="let discount of discounts" [value]="discount.discountId">
                  {{discount.discountDesc}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <ng-container *ngIf="form.value.discountId">

              <mat-form-field fxFlex="50" width="100%">
                <mat-label>Discount Type</mat-label>
                <input matInput type="text" formControlName="discountType">
              </mat-form-field>

              <mat-form-field fxFlex="50" width="100%">
                <mat-label>Value Flag</mat-label>
                <input matInput type="text" formControlName="discountValueFlag">
              </mat-form-field>


              <mat-form-field fxFlex="30" width="100%">
                <mat-label>Min. Amount</mat-label>
                <input matInput style="text-align: right;" type="number" formControlName="discountMinValue">
              </mat-form-field>

              <mat-form-field fxFlex="30" width="100%">
                <mat-label>Max. Amount</mat-label>
                <input matInput style="text-align: right;" type="number" formControlName="discountMaxValue">
              </mat-form-field>

              <mat-form-field fxFlex="40" width="100%">
                <mat-label>Discount Amount</mat-label>
                <input matInput style="text-align: right;" type="number" formControlName="discountValue" autocomplete="new-password">
              </mat-form-field>

              <ng-container *ngIf="form.value.requiresApproval">
                <mat-form-field fxFlex="100" width="100%">
                  <mat-label>Approved By Manager Email</mat-label>
                  <input matInput type="email" formControlName="approvedByEmail" autocomplete="new-password">
                </mat-form-field>

                <mat-form-field fxFlex="100" width="100%">
                  <mat-label>Approved By Manager Password</mat-label>
                  <input matInput type="password" formControlName="approvedByPwd" autocomplete="new-password">
                </mat-form-field>
              </ng-container>

            </ng-container>
          </div>
        </form>
      </form>
    </div>

    <!-- Warehouse Details -->
    <div>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Save</button>
  <button mat-button color="warn" (click)="clearDiscount()">Reset Price</button>
</mat-dialog-actions>
